// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_aSE","cls2":"common-cls2_mJY common-cls1_aSE"};